import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { defineElement } from '@lordicon/element';

defineElement();

/**
 * Lordicon's createPlayer() calls fetch(src) without .catch().
 * React StrictMode (and fast remounts) abort in-flight icon loads →
 * "Failed to fetch" unhandled rejections flood CRA's error overlay.
 */
(() => {
  const Ctor = customElements.get('lord-icon') as (CustomElementConstructor & {
    prototype: { createPlayer?: () => Promise<unknown> };
  }) | undefined;
  const proto = Ctor?.prototype;
  const original = proto?.createPlayer;
  if (!proto || typeof original !== 'function') return;
  proto.createPlayer = function patchedCreatePlayer(this: HTMLElement) {
    return Promise.resolve(original.call(this)).catch((err: unknown) => {
      const msg = err instanceof Error ? err.message : String(err);
      if (process.env.NODE_ENV === 'development' && !/fail(ed)? to fetch|abort/i.test(msg)) {
        console.debug('[lord-icon] load failed', this.getAttribute('src'), msg);
      }
    });
  };
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
